import { postJson } from './apiClient';
import {
  AuthMessageResponse,
  ForgotPasswordRequest,
  LoginRequest,
  LoginResponse,
  PasswordResetValidationResponse,
  PasswordResetRequest,
  PasswordSetupRequest,
  SetupValidationResponse,
} from '../types/auth';

const AUTH_PATH = '/api/auth';

export interface RegisterRequest {
  email: string;
  password: string;

  firstName: string;
  lastName: string;

  companyName: string;
  address: string;
  contactNumber: string;

  role: string;
}

export const authApi = {
  register: (request: RegisterRequest) => postJson<LoginResponse>(`${AUTH_PATH}/register`, request),
  login: (email: string, password: string) => {
    const request: LoginRequest = { email, password };
    return postJson<LoginResponse>(`${AUTH_PATH}/login`, request);
  },
  validateSetup: (token: string) =>
    postJson<SetupValidationResponse>(`${AUTH_PATH}/setup/validate`, { token }),
  completeSetup: (request: PasswordSetupRequest) =>
    postJson<AuthMessageResponse>(`${AUTH_PATH}/setup/complete`, request),
  forgotPassword: (request: ForgotPasswordRequest) =>
    postJson<AuthMessageResponse>(`${AUTH_PATH}/forgot-password`, request),
  validateReset: (token: string) =>
    postJson<PasswordResetValidationResponse>(`${AUTH_PATH}/validate-reset`, { token }),
  resetPassword: (request: PasswordResetRequest) =>
    postJson<AuthMessageResponse>(`${AUTH_PATH}/reset-password`, request),
  logout: () => postJson<void>(`${AUTH_PATH}/logout`),
  microsoftLogin: (idToken: string) =>
    postJson<LoginResponse>(`${AUTH_PATH}/microsoft`, { idToken }),
  googleLogin: (idToken: string) =>
    postJson<LoginResponse>(`${AUTH_PATH}/google`, { idToken }),
};